import { render, staticRenderFns } from "./RiskControls.html?vue&type=template&id=37c3a74e&external"
import script from "./RiskControls.vue?vue&type=script&lang=js"
export * from "./RiskControls.vue?vue&type=script&lang=js"
import style0 from "./RiskControls.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports